import { useQuery, keepPreviousData } from '@tanstack/react-query';

import getNotification from 'Api/notification/getNotification';

import getNotificationRequest from './model/request/getNotificationRequest';
import getNotificationResponse from './model/response/getNotificationResponse';

const useGetNotification = (filter, setPreviousNotification, previousDailySchedule, setUnreadCount) => {
  const REFETCH_INTERVAL = 60000;

  return useQuery({
    queryKey: ['notification', filter],
    queryFn: async () => {
      const queries = getNotificationRequest(filter);

      const response = await getNotification(queries);

      const result = getNotificationResponse(response, previousDailySchedule, filter?.page);

      setPreviousNotification(result?.notifications);

      if (filter?.selectedTab === 'unread') setUnreadCount(result?.totalData);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    placeholderData: keepPreviousData,
    gcTime: 0,
    refetchInterval: REFETCH_INTERVAL,
  });
};

export default useGetNotification;
